module.exports = __webpack_public_path__ + "static/media/services.db63a183.png";